import { makeStyles, TextField, FormControl, InputLabel, Tooltip, Typography, FormHelperText } from '@material-ui/core';
import React from 'react';
import { coursesStyles } from '../styles';
import HelpIcon from '@material-ui/icons/Info';
import PropTypes from 'prop-types';

function OnlinePurchasingTab({ register, isFromOrg, allClinics, selectedCourse, clinic, errors }) {
    const classes = makeStyles(coursesStyles)();
    const urlLocation = clinic === 'organisation' ? (allClinics.length === 1 ? allClinics[0].id : null) : clinic;
    const customerAppUrl = `${JSON.parse(localStorage.getItem('linkCache')).customerAppUrl}/step/${urlLocation}/${
        selectedCourse?.category?.id
    }${selectedCourse ? '/' + selectedCourse?.id : ''}`;

    return (
        <div className={classes.formContent}>
            <div className={classes.onlineBookingContentRow}>
                <FormControl
                    style={{ flex: 1, marginRight: 8, marginTop: 8, marginBottom: 8, width: '50%' }}
                    variant="outlined"
                    error={!!errors?.order}
                >
                    <InputLabel shrink>Order</InputLabel>
                    <TextField
                        style={{ width: '100%', marginTop: 10 }}
                        inputRef={register({
                            pattern: {
                                value: /^[0-9]+$/,
                                message: 'Order must be a number'
                            },
                            min: {
                                value: 0,
                                message: 'Order must be 0 or greater'
                            }
                        })}
                        name="order"
                        variant="outlined"
                        type="number"
                        error={!!errors?.order}
                    />
                    {errors?.order && <FormHelperText error>{errors.order.message}</FormHelperText>}
                </FormControl>
                <div style={{ width: 'auto', marginTop: 18 }}></div>
            </div>

            <div className={classes.onlineBookingContentRow}>
                <FormControl
                    style={{ flex: 1, marginRight: 8, marginTop: 8, marginBottom: 8, width: '50%' }}
                    variant="outlined"
                >
                    <InputLabel shrink>Online name</InputLabel>
                    <TextField
                        style={{ width: '100%', marginTop: 10 }}
                        inputRef={register}
                        name="onlineName"
                        variant="outlined"
                        inputProps={{ readOnly: allClinics > 1 && !isFromOrg }}
                    />
                </FormControl>

                <FormControl style={{ width: 'auto', marginTop: 18 }} variant="outlined">
                    <Tooltip
                        className={classes.tooltip}
                        title={
                            <Typography className={classes.typography}>
                                Use this if you wish the name of this course to appear differently for online booking.
                                Use this wisely as using many different names can make it difficult to know which
                                courses link to those online!
                            </Typography>
                        }
                        aria-label="help"
                    >
                        <HelpIcon className={classes.helpIcon} />
                    </Tooltip>
                </FormControl>
            </div>

            <div className={classes.onlineBookingContentRow}>
                <FormControl
                    style={{ flex: 1, marginRight: 8, marginTop: 8, marginBottom: 8, width: '50%' }}
                    variant="outlined"
                >
                    <InputLabel shrink>Online description</InputLabel>
                    <TextField
                        style={{ width: '100%', marginTop: 10 }}
                        inputRef={register}
                        name="onlineSubtitle"
                        variant="outlined"
                        inputProps={{ readOnly: allClinics > 1 && !isFromOrg }}
                    />
                </FormControl>
                <FormControl style={{ width: 'auto', marginTop: 18 }} variant="outlined">
                    <Tooltip
                        title={
                            <Typography style={{ fontSize: 14 }}>
                                This text will appear below the course name in online booking.
                            </Typography>
                        }
                        aria-label="help"
                    >
                        <HelpIcon className={classes.helpIcon} />
                    </Tooltip>
                </FormControl>
            </div>

            <div className={classes.onlineBookingContentRow}>
                <FormControl
                    style={{ flex: 1, marginRight: 8, marginTop: 8, marginBottom: 8, width: '50%' }}
                    variant="outlined"
                >
                    <InputLabel shrink>Info text</InputLabel>
                    <TextField
                        style={{ width: '100%', marginTop: 10 }}
                        inputRef={register}
                        name="onlineDescription"
                        variant="outlined"
                        inputProps={{ readOnly: allClinics > 1 && !isFromOrg }}
                    />
                </FormControl>
                <FormControl style={{ width: 'auto', marginTop: 18 }} variant="outlined">
                    <Tooltip
                        title={
                            <Typography style={{ fontSize: 14 }}>
                                This text will appear when hovering an info bubble next to the course name in online
                                booking.
                            </Typography>
                        }
                        aria-label="help"
                    >
                        <HelpIcon className={classes.helpIcon} />
                    </Tooltip>
                </FormControl>
            </div>
            {urlLocation && selectedCourse.id && (
                <div className={classes.formContentRow}>
                    <Typography className={classes.typography}>
                        URL:{' '}
                        <a className={classes.linkItem} rel="noopener noreferrer" target="_blank" href={customerAppUrl}>
                            {customerAppUrl}
                        </a>
                    </Typography>
                </div>
            )}
        </div>
    );
}

OnlinePurchasingTab.propTypes = {
    register: PropTypes.func,
    currentCourse: PropTypes.object,
    clinic: PropTypes.any,
    isFromOrg: PropTypes.bool,
    allClinics: PropTypes.array
};

export default OnlinePurchasingTab;
